import { Component, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { UsuarioService } from './app/services/auth/usuario.service';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, ToastModule],
  template: `
    <router-outlet></router-outlet>
    <p-toast></p-toast>
  `
})
export class AppComponent {
  private router = inject(Router);
  private usuarioService = inject(UsuarioService);

  hiddenTime: number | null = null;
  history = signal<string[]>([]);
  constructor() {
    setInterval(() => {
      if (this.history().length <= 3) return;
      // borrar el primer elemento del history
      this.history.update(prev => prev.slice(1));
    }, 5000);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentUrl = event.urlAfterRedirects;
        this.history.update(prev => [...prev, currentUrl]);
      });

    // esta funcion se ejecuta cuando se cambia de pestaña
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  efectoHistory = effect(() => {
    console.warn('history', this.history());
    
    // si el ultimo elemento del history es '/404' entonces last_url es el antepenultimo elemento del history
    if (this.history()[this.history().length - 1] === '/404') {
      let lastUrl = this.history()[this.history().length - 3];
      if (lastUrl && lastUrl !== '/auth/login' && lastUrl !== '/404') {
        sessionStorage.setItem('last_url', lastUrl);
      } else {
        sessionStorage.removeItem('last_url');
      }
    } else {
      let lastUrl = this.history()[this.history().length - 2];
      if (lastUrl && lastUrl !== '/auth/login' && lastUrl !== '/404') {
        sessionStorage.setItem('last_url', lastUrl);
      } else {
        sessionStorage.removeItem('last_url');
      }
    }
  });

  handleVisibilityChange = () => {
    let diezMinutos = 10 * 60 * 1000; // 10 minutos

    if (document.hidden) {
      this.hiddenTime = Date.now();
    } else {
      if (this.hiddenTime && Date.now() - this.hiddenTime >= diezMinutos) {
        this.usuarioService.verificarCaducudadToken();
      }
      this.hiddenTime = null;
    }
  };
}
